import { render, staticRenderFns } from "./GerenciaCadastroDisciplinas.vue?vue&type=template&id=62080389"
import script from "./GerenciaCadastroDisciplinas.vue?vue&type=script&lang=js"
export * from "./GerenciaCadastroDisciplinas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports